import { render, staticRenderFns } from "./BusinessUnitGroups.vue?vue&type=template&id=a0fd4942&scoped=true&"
import script from "./BusinessUnitGroups.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitGroups.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUnitGroups.vue?vue&type=style&index=0&id=a0fd4942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fd4942",
  null
  
)

export default component.exports